// 接口地址
const apiUrl = "http://ws-nocode.com:81/";

export default {
  apiUrl
};



// WEBPACK FOOTER //
// ./src/global/global.js